// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-block[data-v-72233bcd] {\n  margin-top: 20px;\n  margin-bottom: 0px;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
